<template lang="pug">
#pessoa-operacao
    card
        el-form.form(label-position="top" size="small")
            .pessoa
                el-form-item.w-66
                    template(slot="label")
                        span.campo_obrigatorio {{ $t('mensagens.comuns.pessoa') }}
                    el-select.w-100(
                        v-model="idPessoaSelecionada"
                        :placeholder="$t('mensagens.operacao.formularioPessoa.buscaInteligente')"
                        filterable
                        remote
                        reserve-keyword
                        :remote-method="remoteMethod")
                        el-option(
                            v-for="pessoa in listaPessoas"
                            :key="'pessoa' + pessoa.id"
                            :label="pessoa.nomeRazaoSocial + ' - ' + numeralStringFormatTocpfCnpj(pessoa.cpfCnpj)"
                            :value="pessoa.id")
                        div(style="padding: 5px")
                            BaseButton.pessoa__btn-cadastro(
                                icon='el-icon-plus'
                                @click='cadastrarPessoa'
                                size='mini')
                                | {{ $t('mensagens.operacao.formularioPessoa.cadastrarPessoa') }}
                el-form-item.w-33
                    template(slot="label")
                        span.campo_obrigatorio {{ $t('mensagens.operacao.formularioPessoa.papel') }}
                    el-select.w-100(
                        v-model="idPapelSelecionado"
                        :placeholder="$t('mensagens.operacao.acoes.selecione')")
                        el-option(
                            v-for='papel in listaPapeis'
                            :key="'papel' + papel.id"
                            :label="papel.nome"
                            :value="papel.id")
                el-form-item(style="40px")
                    el-tooltip(:content="$t('mensagens.operacao.acoes.adicionar')" placement="bottom-end" effect="light")
                        i.el-icon-circle-plus-outline.icon(@click='addPessoa()')

        span.titulo {{ $t('mensagens.operacao.formularioPessoa.pessoasAdicionadas') }}
        <br/>
        el-row.tabela(:gutter='24')
            el-col.mb-2(:span='5')
                span.tituloColuna {{ $t('mensagens.operacao.tabela.nomeRazaoSocial') }}
            el-col.mb-2(:span='3')
                span.tituloColuna {{ $t('mensagens.operacao.tabela.documento') }}
            el-col.mb-2(:span='3')
                span.tituloColuna {{ $t('mensagens.operacao.formularioPessoa.papel') }}
            el-col.mb-2(:span='3')
                span.tituloColuna {{ $t('mensagens.operacao.formularioPessoa.idPessoa') }}
            el-col.mb-2(:span='4')
                span.tituloColuna {{ $t('mensagens.operacao.tabela.restricaoSocio') }}
            el-col.mb-2(:span='2')
                span.tituloColuna {{ $t('mensagens.operacao.acoes.remover') }}
            el-col(v-if="pessoasOperacoes.length > 0" :span='24', style='padding: 0; display: grid')
                div.w-100(v-for='(pessoaOp, index) in pessoasOperacoes')
                    el-form(:model='pessoaOp' :ref="'formPessoa' + index")
                        el-col(:span='5')
                            span {{ pessoaOp.pessoa.nomeRazaoSocial }}
                        el-col(:span='3')
                            span {{ numeralStringFormatTocpfCnpj(pessoaOp.pessoa.cpfCnpj) }}
                        el-col(:span='3')
                            el-form-item.margin(prop='papel')
                                el-select(
                                    v-model="pessoaOp.papel"
                                    :placeholder="$t('mensagens.operacao.acoes.selecione')"
                                    style="width: 100%"
                                    @change="atualizarListaPessoas"
                                    value-key="id")
                                    el-option(
                                        v-for='papel in listaPapeis'
                                        :key='papel.id'
                                        :label="papel.nome"
                                        :value="papel")
                        el-col(:span='3')
                            span {{ pessoaOp.pessoa.idCliente }}
                        el-col(:span='4')
                            div(style='display: flex')
                                i.mr-2.flow.flow-verified.verde.mr8.custon-icon(v-if="pessoaOp.pessoa.restricao === 'nao'")
                                i.mr-2.flow.flow-warning-sign.vermelho.custon-icon(v-else-if="pessoaOp.pessoa.restricao === 'sim'")
                                span {{ $t(`mensagens.comuns.${pessoaOp.pessoa.restricao}`) }}
                                el-tooltip(v-if="pessoaOp.pessoa.resultado" :content="$t('mensagens.operacao.formularioPessoa.visualizarResultado')" placement="bottom-end" effect="light")
                                    i.el-icon-view.icon-view(@click='visualizarDiagnostico(pessoaOp)')
                        el-col(:span='2')
                            i.el-icon-delete.icon-remover(@click='openModalRemover(pessoaOp)')
            el-col(v-if="pessoasOperacoes.length === 0" :span='24', style='padding: 0; text-align: center')
                div.w-100
                span.sem-registro {{ $t('mensagens.operacao.formularioPessoa.nenhumaPessoaAdicionada') }}

        #modal-delete-pessoa.row(v-if='deletePessoaModal')
            el-dialog(:visible.sync='deletePessoaModal', width='500px')
                span(slot="title")
                    h1.mb-2.font-weight-bold(style='text-align: left; font-size: 18px') {{ $t('mensagens.operacao.formularioPessoa.removerPessoa') }}
                .column.d-flex.justify-content-center.align-items-center.flex-column
                    h2.mb16() {{ $t('mensagens.operacao.formularioPessoa.confirmaRemoverRegistro') }}
                    .buttons.mb16()
                        BaseButton(size="mini", @click='closeModalRemover')
                            | {{ $t('mensagens.operacao.acoes.cancelar') }}
                        BaseButton(type="primary", size="mini", @click='deletePessoa')
                            | {{ $t('mensagens.operacao.acoes.remover') }}

        ModalResultadoDiagnosticoPessoa(
            confirmar
            :mostrar='mostrarModalDiagnosticoPessoa'
            :pessoa='pessoa'
            @fechar='mostrarModalDiagnosticoPessoa = false')

        ModalEditarCadastrarRepresentante(
            :mostrar='mostrarModalEditarCadastrarRepresentante'
            :dadosRepresentante='pessoa'
            @atualizarListaRepresentantes='buscarPessoas'
            @fechar='fecharModalEditarCadastrarRepresentante')

</template>

<script>
import Card from '../../Card.vue';
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import RepresentanteService from '@/services/RepresentanteService';
import OperacaoService from '@/services/OperacaoService';
import DiagnosticoSocioambientalProtocoloService from '@/services/DiagnosticoSocioambientalProtocoloService';
import ModalResultadoDiagnosticoPessoa from '@/components/operacao/gestao/ModalResultadoDiagnosticoPessoaOperacao.vue';
import ModalEditarCadastrarRepresentante from '@/components/ModalEditarCadastrarRepresentante.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'FormularioPessoaOperacao',

    components: {
        Card,
        ModalResultadoDiagnosticoPessoa,
        ModalEditarCadastrarRepresentante,
        BaseButton
    },

    emits: ['dadosPessoa'],

    props: {
        operacaoEditarOuClonar: {
            type: Object,
            required: false,
            default: null
        },
        produtos: {
            type: Array,
            required: false,
            default: () => []
        }
    },

    data() {
        return {
            idPessoaSelecionada: null,
            idPapelSelecionado: null,
            listaPessoas: [],
            listaPapeis: [],
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 5
            },
            pessoasOperacoes: [],
            pessoaOperacaoSelecionada: null,
            deletePessoaModal: false,
            mostrarModalDiagnosticoPessoa: false,
            mostrarModalEditarCadastrarRepresentante: false,
            pessoa: {}
        };
    },

    async mounted() {
        await this.buscarPessoas();
        await this.buscarPapeis();
        setTimeout(async () => this.verificarEdicao(), 1000);
    },

    methods: {
        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        remoteMethod(query) {
            setTimeout(() => {
                this.buscarPessoas(query);
            }, 800);
        },

        getFiltros(query) {
            const filtro = {};
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.searchText = query || '';
            if (validators.validarCPF(filtro.searchText.replace(/[.\-/]/g, '')) || validators.validarCNPJ(filtro.searchText.replace(/[.\-/]/g, ''))) {
                filtro.searchText = formatters.documentoFormatToNumeral(query);
            }
            filtro.order = '&sort=nome_razao_social,asc';
            return filtro;
        },

        async buscarPessoas(query) {
            try {
                const { data } = await RepresentanteService.findAllByFiltro(
                    this.getFiltros(query)
                );
                this.listaPessoas = data.resultados;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.falhaCarregamentoDadosPessoas')
                });
            }
        },

        async buscarPapeis() {
            try {
                const { data } = await OperacaoService.buscarPapeisPessoa();
                this.listaPapeis = data.itens;
            } catch (error) {
                this.$notify.error({
                    message: error.message
                });
            }
        },

        async addPessoa() {
            if (!this.idPessoaSelecionada || !this.idPapelSelecionado) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.selecaoPessoaPapel')
                });
                return;
            }

            const checagem = this.pessoasOperacoes.find(
                p =>
                    p.pessoa.id === this.idPessoaSelecionada &&
                    p.papel.id === this.idPapelSelecionado
            );

            if (checagem) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.pessoaPapelJaSelecionada')
                });
                return;
            }

            const pessoaSelecionada = this.listaPessoas.find(
                p => p.id === this.idPessoaSelecionada
            );

            const numeroCpfCnpj = formatters.documentoFormatToNumeral(
                pessoaSelecionada.cpfCnpj
            );

            const idsProdutos = this.produtos.map(atividade => {
                return atividade.idProduto;
            });

            try {
                const { data } =
                    await DiagnosticoSocioambientalProtocoloService.consultar(
                        'CPF_CNPJ',
                        numeroCpfCnpj,
                        this.operacaoEditarOuClonar?.dadosGerais?.id,
                        idsProdutos
                    );
                pessoaSelecionada.resultado = data.diagnostico;

                const restricao = pessoaSelecionada.resultado.filter(
                    d => d.resultados.length > 0
                );

                if (restricao.length > 0) {
                    pessoaSelecionada.restricao = 'sim';
                } else {
                    pessoaSelecionada.restricao = 'nao';
                }

                pessoaSelecionada.diagnostico = {
                    diagnostico: pessoaSelecionada.resultado
                };
            } catch (error) {
                pessoaSelecionada.diagnostico = null;
                pessoaSelecionada.restricao = '-';

                this.$notify.error({
                    message:
                        this.$t('mensagens.operacao.notificacao.erroDiagnosticoSocio')
                });
            }

            if (!pessoaSelecionada.email) {
                pessoaSelecionada.email = '-';
            }

            if (!pessoaSelecionada.idCliente) {
                pessoaSelecionada.idCliente = '-';
            }

            const papelSelecionado = this.listaPapeis.find(
                p => p.id === this.idPapelSelecionado
            );

            this.pessoasOperacoes.push({
                pessoa: pessoaSelecionada,
                papel: papelSelecionado
            });

            this.idPessoaSelecionada = null;
            this.idPapelSelecionado = null;
            this.listaPessoas = [];
            this.buscarPessoas();

            this.atualizarListaPessoas();
        },

        openModalRemover(pessoaOperacao) {
            this.pessoaOperacaoSelecionada = pessoaOperacao;
            this.deletePessoaModal = true;
        },

        closeModalRemover() {
            this.deletePessoaModal = false;
        },

        deletePessoa() {
            if (this.pessoaOperacaoSelecionada) {
                this.pessoasOperacoes.splice(
                    this.pessoasOperacoes.indexOf(
                        this.pessoaOperacaoSelecionada
                    ),
                    1
                );
                this.deletePessoaModal = false;
                this.atualizarListaPessoas();
            }
        },

        cadastrarPessoa() {
            this.editar = false;
            this.mostrarModalEditarCadastrarRepresentante = true;
        },

        fecharModalEditarCadastrarRepresentante() {
            this.dadosRepresentanteCadastro = {};
            this.mostrarModalEditarCadastrarRepresentante = false;
        },

        visualizarDiagnostico(pessoaOperacao) {
            this.pessoa = pessoaOperacao.pessoa;
            this.mostrarModalDiagnosticoPessoa = true;
        },

        atualizarListaPessoas() {
            const pessoas = [];
            this.pessoasOperacoes.forEach(pp => {
                pessoas.push({
                    idPessoa: pp.pessoa.id,
                    idPapel: pp.papel.id,
                    cpfCnpj: pp.pessoa.cpfCnpj,
                    nomeRazaoSocial: pp.pessoa.nomeRazaoSocial
                });
            });
            this.$emit('dadosPessoa', pessoas);
        },

        async verificarEdicao() {
            if (this.operacaoEditarOuClonar !== null) {
                this.pessoasOperacoes =
                    this.operacaoEditarOuClonar.pessoasGrupoEconomico;

                for (const pp of this.pessoasOperacoes) {
                    try {
                        const { data } =
                            await DiagnosticoSocioambientalProtocoloService.consultar(
                                'CPF_CNPJ',
                                pp.pessoa.cpfCnpj,
                                this.operacaoEditarOuClonar.dadosGerais.id
                            );
                        pp.pessoa.resultado = data.diagnostico;

                        const restricao = pp.pessoa.resultado.filter(
                            d => d.resultados.length > 0
                        );

                        if (restricao.length > 0) {
                            pp.pessoa.restricao = 'sim';
                        } else {
                            pp.pessoa.restricao = 'nao';
                        }

                        pp.pessoa.diagnostico = {
                            diagnostico: pp.pessoa.resultado
                        };
                    } catch (error) {
                        pp.pessoa.diagnostico = null;
                        pp.pessoa.restricao = '-';

                        this.$notify.error({
                            message:
                                this.$t('mensagens.operacao.notificacao.erroDiagnosticoSocio')
                        });
                    }

                    if (!pp.pessoa.email) {
                        pp.pessoa.email = '-';
                    }

                    if (!pp.pessoa.idCliente) {
                        pp.pessoa.idCliente = '-';
                    }
                }

                this.atualizarListaPessoas();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#pessoa-operacao {
    .form {
        padding: 2px 2px 2px 0;

        .pessoa {
            display: flex;
            justify-content: space-between;
        }
    }

    .w-100 {
        width: 100%;
    }

    .w-66 {
        width: 66%;
        padding-right: 10px;
    }

    .w-33 {
        width: 33%;
    }

    .icon {
        font-size: 25px;
        cursor: pointer;
        padding-top: 36px;
        padding-left: 8px;
        color: var(--primary);
    }

    .icon-remover {
        font-size: 22px;
        cursor: pointer;
        padding-left: 18px;
        color: #900000;
    }

    .icon-view {
        font-size: 20px;
        cursor: pointer;
        padding-left: 18px;
    }

    .tabela {
        width: 100%;
        padding-top: 15px;
        padding-bottom: 10px;
        padding-left: 15px;
    }

    .titulo {
        font-size: 14px;
        color: dimgray;
    }

    .sem-registro {
        font-size: 14px;
        color: var(--secondary-font-color);
    }

    .tituloColuna {
        font-size: 15px;
        color: var(--primary);
    }

    .margin {
        margin-bottom: 12px;
    }

    #modal-delete-pessoa {
        text-align: center;
    }

    .pessoa__btn-cadastro {
        border-radius: 20px !important;
    }

    .mb16 {
        margin-bottom: 16px;
    }

    .vermelho {
        color: red;
    }

    .verde {
        color: green;
    }

    .custon-icon {
        font-size: 16px;
    }

    .campo_obrigatorio::before {
        content: '* ';
        color: red;
    }

    .campo_obrigatorio {
        font-size: 14px;
        color: var(--primary);
        font-weight: normal !important;
    }
}
</style>
